var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Input from '../../../../components/Input';
import { injectIntl } from 'react-intl';
import translate from '../../../../lib/utils/translate';

var BonusCodeInput = function (_Component) {
  _inherits(BonusCodeInput, _Component);

  function BonusCodeInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BonusCodeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BonusCodeInput.__proto__ || Object.getPrototypeOf(BonusCodeInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showInput: false
    }, _this.showInput = function () {
      _this.setState({
        showInput: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BonusCodeInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bonusCode = _props.bonusCode,
          intl = _props.intl,
          disabled = _props.disabled,
          onChange = _props.onChange,
          status = _props.status;


      if (bonusCode || this.state.showInput) {
        return React.createElement(
          'div',
          { className: 'bonus-code-input-wrapper' },
          React.createElement(Input, {
            name: 'bonusCode',
            value: bonusCode,
            onChange: onChange,
            autoFocus: true,
            label: translate({ id: 'cashier.bonus_code' }, intl),
            disabled: disabled,
            status: status === 'active' && 'success' || status === 'pending' && 'loading'
          })
        );
      }

      return React.createElement(
        'div',
        { className: 'bonus-code-input-wrapper' },
        React.createElement(
          'a',
          { onClick: this.showInput },
          translate({ id: 'message.have_bonus_code' }, intl)
        )
      );
    }
  }]);

  return BonusCodeInput;
}(Component);

export default injectIntl(BonusCodeInput);